module.exports = __webpack_public_path__ + "img/reviews.c9983234.png";